/**
 * Issues Page Component
 *
 * Displays resources and information about equal shared parenting issues
 */

import React from 'react'
import { Box } from '@mui/material'
import { ResourcesSection } from '@/components/sections/ResourcesSection'
import { resourcesContent } from '@/data'
import SEOMetaTags from '@/components/SEOMetaTags'
import { getSEOConfig, getCanonicalUrl } from '@/utils/seo'

/**
 * Issues Page Component
 */
const Issues: React.FC = () => {
  // Get SEO configuration for this page
  const seoConfig = getSEOConfig('/issues')!
  const canonicalUrl = getCanonicalUrl('/issues')

  return (
    <Box component="main" role="main">
      {/* SEO Meta Tags */}
      <SEOMetaTags
        title={seoConfig.title}
        description={seoConfig.description}
        canonical={canonicalUrl}
        ogImage={seoConfig.ogImage}
        keywords={seoConfig.keywords}
        noIndex={seoConfig.noIndex}
      />
      {/* Resources & Information Section */}
      <ResourcesSection content={resourcesContent} />
    </Box>
  )
}

export default Issues
